import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReloadOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const ReloadContainer = styled.span`
  font-size: 20px;
  cursor: pointer;
  white-space: nowrap;
  svg{
    margin-right: 10px;
  }

  a, a:hover, a:active, a:focus {
    color: white;
  }
`;

const Refresh = () => {
  const { t } = useTranslation();

  return (<ReloadContainer className="refreshButton" onClick={() => window.location.reload()}>
    <ReloadOutlined/> {t('refreshPage')}
  </ReloadContainer>);
};

export default Refresh;
